import React, { useRef } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import styles from "../consents.module.scss.js";
const ExplicitConsentTransition = ({
  transitionDuration,
  showDetails,
  details,
  closeText,
  onClick
}) => {
  const setMaxHeightFromTo = (from, to, element) => new Promise((resolve) => {
    element.style.maxHeight = from;
    setTimeout(() => {
      element.style.maxHeight = to;
      resolve();
    }, 0);
  });
  const durationSlow = 450;
  const nodeRef = useRef(null);
  const nodeRefCurrent = nodeRef.current;
  const getContentHeight = (element) => {
    const el = element.querySelector("div");
    return el ? window.getComputedStyle(el).height : "0";
  };
  if (!nodeRef || !nodeRefCurrent) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(TransitionGroup, null, showDetails && /* @__PURE__ */ React.createElement(
    CSSTransition,
    {
      classNames: { enter: "enter", exit: "exit" },
      timeout: {
        enter: durationSlow * transitionDuration,
        exit: durationSlow * transitionDuration
      },
      nodeRef,
      onEnter: () => {
        nodeRefCurrent.style.transitionDuration = `calc(0.45s * ${transitionDuration})`;
        const contentHeight = getContentHeight(nodeRefCurrent);
        return setMaxHeightFromTo("0", contentHeight, nodeRefCurrent);
      },
      onEntered: () => {
        nodeRefCurrent.style.maxHeight = "none";
      },
      onExiting: () => {
        const contentHeight = getContentHeight(nodeRefCurrent);
        return setMaxHeightFromTo(contentHeight, "0", nodeRefCurrent);
      }
    },
    /* @__PURE__ */ React.createElement("div", { ref: nodeRef, className: `${styles[styles.details]} gl-vspace` }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      "div",
      {
        dangerouslySetInnerHTML: {
          __html: details || ""
        }
      }
    ), /* @__PURE__ */ React.createElement("div", { className: "gl-vspace" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "gl-link", "data-auto-id": "consent-details-close", onClick }, closeText))))
  ));
};
export {
  ExplicitConsentTransition,
  ExplicitConsentTransition as default
};
//# sourceMappingURL=explicit-consent-transition.js.map
